import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Scroll,
  Container,
  LeftPanelContainer,
  WebContainer,
  Wrapper,
  Row,
  KeyboardView,
  Title,
  Copy,
  Card
} from "app/NativeComponents/common";
import { Header, CardLabel, MenuItem } from "app/NativeComponents/snippets";

import {
  lockDrawer,
  toggleDrawer,
  mobileToggleDrawer,
  toggleCanPop,
  changeTab,
  appRedirect,
  toggleModal,
  setModal,
  toggleActionSheet,
  updateConversationFilter,
  updateConversation,
  getConversations,
  setActiveConversation,
  getTeamPhoneNumbers,
  checkIfUserHasModule
} from "app/NativeActions";

import ConversationList from "./ConversationList";
import ConversationSearch from "./ConversationSearch";

import OnboardingContainer from "app/DealMachineCore/snippets/OnboardingContainer";
import MessageOnboardingSteps from "./MessageOnboardingSteps";

import MessageDashboardStats from "./MessageDashboardStats";
import Webinars from "app/DealMachineCore/components/Dashboard/News/Webinars";

class MessageDashboard extends Component {
  constructor(props) {
    super(props);
    const plan_module_info = checkIfUserHasModule({
      plan_modules: props.plan_modules,
      user: props.user,
      slug: "messages"
    });
    this.state = {
      plan_module_info: plan_module_info
    };

    this.getTeamConversations = this.getTeamConversations.bind(this);
  }
  componentWillUnmount() {
    clearInterval(this._search_interval);
  }

  componentDidMount() {
    if (this.props.user.team_clearance_level == 0) {
      this.props.appRedirect({ redirect: "dashboard" });
    }
    if (this.props.device == "mobile") {
      this.props.toggleCanPop("");
      this.props.lockDrawer(false);
    }

    this.props.changeTab("messages");

    this.getTeamConversations();
    this.props.getTeamPhoneNumbers({ token: this.props.token });
  }

  getTeamConversations(
    load_type = "load",
    search = "",
    begin = this.props.conversations_begin
  ) {
    if (
      !this.props.conversations_loading &&
      !this.props.conversations_refreshing
    ) {
      this.props.getConversations({
        token: this.props.token,
        load_type: load_type,
        search: search,
        filter_type: this.props.conversations_filters.filter_type,
        sort_by: this.props.conversations_filters.sort_by,
        begin: load_type === "refresh" ? 0 : begin,
        limit: this.props.conversations_limit
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.conversations_filters &&
      prevProps.conversations_filters &&
      prevProps.conversations_filters.search !==
        this.props.conversations_filters.search &&
      (this.props.conversations_filters.search.length > 2 ||
        this.props.conversations_filters.search.length == 0)
    ) {
      clearInterval(this._search_interval);
      this._search_interval = setTimeout(() => {
        this.getTeamConversations(
          "refresh",
          this.props.conversations_filters.search
        );
      }, 250);
    }

    if (
      this.props.conversations_filters &&
      prevProps.conversations_filters &&
      (prevProps.conversations_filters.filter_type !=
        this.props.conversations_filters.filter_type ||
        prevProps.conversations_filters.sort_by !=
          this.props.conversations_filters.sort_by)
    ) {
      this.getTeamConversations("refresh", this.props.conversations_search);
    }

    if (prevProps.user && prevProps.plan_modules) {
      if (
        this.props.plan_modules !== prevProps.plan_modules ||
        this.props.user.plan_modules !== prevProps.user.plan_modules
      ) {
        const plan_module_info = checkIfUserHasModule({
          plan_modules: this.props.plan_modules,
          user: this.props.user,
          slug: "messages"
        });
        this.setState({ plan_module_info: plan_module_info });
      }
    }

    if (
      prevProps.conversations &&
      this.props.conversations &&
      this.props.conversations.length < prevProps.conversations.length &&
      !this.props.conversations_loaded_all
    ) {
      this.getTeamConversations(
        "load_more",
        this.props.conversations_search,
        this.props.conversations.length
      );
    }
  }

  renderMiddle() {
    if (!this.props.active_conversation) {
      return (
        <Container includeInfoBanner={"messages_info_banner"}>
          <WebContainer>
            <Wrapper style={{ padding: 20 }}>
              <MessageDashboardStats />
              {this.props.user.team_clearance_level >= 2 ||
              this.props.user.team_owner == 1 ? (
                <Card>
                  <CardLabel
                    title={"Admin Options:"}
                    icon={""}
                    hasButton={false}
                    onPress={() => {}}
                    hasBorder={true}
                  />
                  <MenuItem
                    to="/a/messages/manage-phone-numbers"
                    onPress={() => {
                      this.props.setActiveConversation({
                        conversation: "manage_phone_numbers"
                      });
                      this.props.appRedirect({
                        redirect: "manage_phone_numbers"
                      });
                    }}
                    title="Manage Phone Numbers"
                    text={""}
                  />
                  <MenuItem
                    to="/a/messages/manage-saved-replies"
                    onPress={() => {
                      this.props.setActiveConversation({
                        conversation: "manage_saved_replies"
                      });
                      this.props.appRedirect({
                        redirect: "manage_saved_replies"
                      });
                    }}
                    title="Manage Saved Replies"
                    text={""}
                  />
                  <MenuItem
                    to="/a/messages/conversation-settings"
                    onPress={() => {
                      this.props.setActiveConversation({
                        conversation: "conversation_settings"
                      });
                      this.props.appRedirect({
                        redirect: "conversation_settings"
                      });
                    }}
                    title="Conversation Settings"
                    text={""}
                  />
                </Card>
              ) : null}
              <Webinars />
            </Wrapper>
          </WebContainer>
        </Container>
      );
    }
  }

  render() {
    if (
      this.state.plan_module_info &&
      (!this.state.plan_module_info.has_module ||
        this.props.card_info.bad_card == 1)
    ) {
      return (
        <OnboardingContainer
          includeInfoBanner={true}
          slug="messages"
          contentful_slug="messages"
          title={"Messages"}
          plan_module_info={this.state.plan_module_info}
          leftButtonIcon={"menu"}
          leftButtonAction={
            this.props.device == "desktop"
              ? () => {
                  this.props.mobileToggleDrawer(
                    !this.props.mobile_toggle_drawer
                  );
                }
              : () => this.props.toggleDrawer("open")
          }
        />
      );
    }

    if (!this.props.user.completed_message_steps) {
      return <MessageOnboardingSteps {...this.props} />;
    }

    if (
      !this.props.isMobile ||
      this.props.active_conversation == null ||
      this.props.device == "mobile"
    ) {
      if (this.props.device == "mobile") {
        return (
          <Container includeInfoBanner={"messages_info_banner"}>
            <ConversationSearch
              updateFilterType={this.updateFilterType}
              updateSortBy={this.updateSortBy}
              filter_type={this.state.filter_type}
              sort_by={this.state.sort_by}
              sort_by_title={this.state.sort_by_title}
              filter_title={this.state.filter_title}
              {...this.props}
            />

            <ConversationList
              {...this.props}
              getTeamConversations={this.getTeamConversations}
            />
          </Container>
        );
      } else if (this.props.isMobile) {
        return (
          <Container includeInfoBanner={"messages_info_banner"}>
            <Scroll style={{ flex: 1 }}>
              <ConversationSearch
                updateFilterType={this.updateFilterType}
                updateSortBy={this.updateSortBy}
                filter_type={this.state.filter_type}
                sort_by={this.state.sort_by}
                sort_by_title={this.state.sort_by_title}
                filter_title={this.state.filter_title}
                {...this.props}
              />

              <KeyboardView>
                <ConversationList
                  {...this.props}
                  getTeamConversations={this.getTeamConversations}
                />
                <Wrapper style={{ marginBottom: 50 }} />
              </KeyboardView>
            </Scroll>
          </Container>
        );
      }

      if (this.props.active_conversation == null) {
        return (
          <Row style={{ alignItems: "flex-start", flex: 1 }}>
            <LeftPanelContainer type="list" style={{ overflowY: "auto" }}>
              <Scroll style={{ flex: 1 }}>
                <ConversationSearch
                  updateFilterType={this.updateFilterType}
                  updateSortBy={this.updateSortBy}
                  filter_type={this.state.filter_type}
                  sort_by={this.state.sort_by}
                  sort_by_title={this.state.sort_by_title}
                  filter_title={this.state.filter_title}
                  {...this.props}
                />

                <KeyboardView>
                  <ConversationList
                    {...this.props}
                    getTeamConversations={this.getTeamConversations}
                  />
                  <Wrapper style={{ marginBottom: 50 }} />
                </KeyboardView>
              </Scroll>
            </LeftPanelContainer>
            {this.renderMiddle()}
          </Row>
        );
      }

      return (
        <LeftPanelContainer type="list" style={{ overflowY: "auto" }}>
          <Scroll style={{ flex: 1 }}>
            <ConversationSearch {...this.props} />

            <KeyboardView>
              <ConversationList
                {...this.props}
                getTeamConversations={this.getTeamConversations}
              />
              <Wrapper style={{ marginBottom: 50 }} />
            </KeyboardView>
          </Scroll>
        </LeftPanelContainer>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, native, settings, billing, message }) => {
  const { token, user } = auth;
  const {
    device,
    platform,
    isMobile,
    dashboardMobile,
    isIphoneX,
    mobile_toggle_drawer
  } = native;
  const { colors, dark_mode } = settings;
  const { plan_modules, card_info } = billing;
  const {
    conversations_filters,
    conversations,
    conversations_loading,
    conversations_refreshing,
    conversations_begin,
    conversations_loaded_all,
    conversations_limit,
    active_conversation,
    active_conversation_loading,
    update_conversation_loading
  } = message;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    dashboardMobile,
    isIphoneX,
    mobile_toggle_drawer,
    colors,
    dark_mode,
    plan_modules,
    card_info,

    conversations_filters,
    conversations,
    conversations_loading,
    conversations_refreshing,
    conversations_begin,
    conversations_loaded_all,
    conversations_limit,
    active_conversation,
    active_conversation_loading,
    update_conversation_loading
  };
};

export default connect(mapStateToProps, {
  lockDrawer,
  toggleDrawer,
  mobileToggleDrawer,
  toggleCanPop,
  changeTab,
  appRedirect,
  toggleModal,
  setModal,
  toggleActionSheet,
  getConversations,
  setActiveConversation,
  updateConversationFilter,
  getTeamPhoneNumbers,
  updateConversation
})(MessageDashboard);
